<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Banner Management <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg"
							alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewBanner()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add
					Banner</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadBanners($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>
					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table #dt [value]="bannerlist" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadBanners($event)" [totalRecords]="totalRecords"
						[rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped p-datatable">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="banner_title">
									<div class="p-d-flex p-jc-between p-ai-center">
										Banner Title
										<p-sortIcon field="banner_title"></p-sortIcon>
									</div>
								</th>

								<th class="viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Banner Images
									</div>
								</th>
								<th pSortableColumn="mobile_banner_title">
									<div class="p-d-flex p-jc-between p-ai-center">
										Mobile Banner Title
										<p-sortIcon field="banner_title"></p-sortIcon>
									</div>
								</th>
								<th class="viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Mobile Banner
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD  p-frozen-column">
									Action
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="banner_title">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'banner_title', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['banner_title'] ? dt.filters['banner_title'].value : ''" [(ngModel)]="banner_title" />
								</th>
								<th class="viewBtnTd">
								</th>
								<th [ngSwitch]="mobile_banner_title">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobile_banner_title', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['mobile_banner_title'] ? dt.filters['mobile_banner_title'].value : ''" [(ngModel)]="mobile_banner_title" />
								</th>
								<th class="viewBtnTd">
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId [options]="statuses"
										(onChange)="setDownloadFlag();dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" [(ngModel)]="createdby" />
								</th>
								<th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" appendTo="body"
										dateFormat="dd/mm/yy" (onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										[showIcon]="true" monthNavigator="true" yearNavigator="true"
										yearRange="2022:2050" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" [(ngModel)]="updatedby" />
								</th>
								<th class="actionTD  p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-banner>
							<tr class="p-selectable-row">
								<td>
									{{banner.banner_title}}
								</td>
								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="banner.banner_image"
										[(visible)]="banner.bannerVisible" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [numVisible]="7" [circular]="true"
										[fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
										[baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="item.banner_image_src"
												style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="banner.banner_image.length > 0" type="button"
										icon="pi pi-eye" label="View" (click)="banner.bannerVisible=true"></button>
								</td>
								<td>
									{{banner.mobile_banner_title}}
								</td>
								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="banner.mobile_banner_image"
										[(visible)]="banner.mobileBannerVisible" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [numVisible]="7" [circular]="true"
										[fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
										[baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="item.banner_image_src"
												style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="banner.mobile_banner_image.length > 0" type="button"
										icon="pi pi-eye" label="View"
										(click)="banner.mobileBannerVisible=true"></button>
								</td>
								<td class="statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="banner.status" (onChange)="changeStatus(banner)">
										</p-inputSwitch>
										<div class="label activeText" *ngIf="banner.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!banner.status">
											Inactive
										</div>
									</div>
								</td>
								<td>
									{{banner.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td>
									{{banner.createdBy}}
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									<span
										*ngIf="banner.updated_at != undefined && banner.updated_at  !='Invalid Date'">{{banner.updated_at
										| date: 'dd/MM/yyyy'}}</span>
								</td>
								<td [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{banner.updatedBy}}
								</td>
								<td class="actionTD  p-frozen-column">
									<ul class="actionList">
										<li>
											<button (click)="editBanner(banner.id)" class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li *ngIf="this.bannerPermissions['edit'] && this.bannerPermissions['view']">
											<button (click)="deleteBanner(banner)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="12">No Banners found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>